import { render, staticRenderFns } from "./PageIndicators.vue?vue&type=template&id=04d56abd&scoped=true&"
import script from "./PageIndicators.vue?vue&type=script&lang=js&"
export * from "./PageIndicators.vue?vue&type=script&lang=js&"
import style0 from "./PageIndicators.vue?vue&type=style&index=0&id=04d56abd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d56abd",
  null
  
)

export default component.exports